import {getStore} from '@/util/store'

//string 专用，
export function getInsureTypesString() {
	let insureTypes = getStore({name: 'insureTypes'})
	return insureTypes.map(({type, name}) => {
		//转换为 label value
		return {label: name, value: type}
	})
}

export function getInsureTypesArray() {
	let insureTypes = getStore({name: 'insureTypes'})
	return insureTypes.map(({type}) => type)
}

//通过insureTypes 获取 对应的 名称
export function getInsureTypeName(tempType = '') {
	let insureTypes = getStore({name: 'insureTypes'})
	if (!tempType) {
		return ''
	}
	tempType = parseInt(tempType)
	let tempData = insureTypes.find(({type}) => type === tempType) || {}
	return tempData.name || ''
}
